import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ToneOfVoicePage = loadAsyncComponent(
  () => import(/* webpackChunkName: "ToneOfVoicePage" */ './Container'),
  'page'
);
